/*
 * @Author: Teemo Ding
 * @Date: 2022-04-17 13:53:57
 * @LastEditTime: 2023-04-14 15:37:16
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Components/DateRange/index.tsx
 */
// import { useRequest } from 'ahooks';
// import { getDateRange } from '@/src/request/analytics/report';
import { Select, Button } from '@/src/components/Antd';
import { IDateRange, IOrderTime } from '@/src/types/common/report';
import type { RangePickerProps } from 'antd/es/date-picker';
import moment from 'moment';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './style.module.less';
import { ICategory } from '@/src/types/common/report';
import { RangePicker } from 'src/components/Antd/DateRangePicker';
const Option = Select.Option;

const DateRange = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    value,
    onChange,
    timeZone,
    onRefresh,
    refreshDate,
    disabled,
    size = 'large',
    type,
    onButtonClick,
    searchBtnLoading,
  } = props;
  const {
    dateRange = '',
    beginDate = '',
    endDate = '',
    dateRangeType,
  } = value || {};
  const isCustom = IDateRange.Custom === dateRange;
  const isPromotion = type === ICategory.Promotion;

  const generatorOptions = () => {
    if (type === ICategory.OrderLineItemsReport) {
      return [
        {
          value: IOrderTime.OrderPaidTime,
          label: getI18n('general.orderPaidDate'),
        },
        {
          value: IOrderTime.OrderCreatedTime,
          label: getI18n('general.orderCreatedDate'),
        },
      ];
    }
    if (type === ICategory.Customer) {
      return [
        {
          value: IOrderTime.RegistrationDate,
          label: getI18n('general.registrationDate'),
        },
      ];
    }
    if (type === ICategory.Product) {
      return [
        {
          value: IOrderTime.ProductCreatedDate,
          label: getI18n('general.productCreatedDate'),
        },
      ];
    }
    if (type === ICategory.Payment) {
      return [
        {
          value: IOrderTime.OrderPaidTime,
          label: getI18n('general.orderPaidDate'),
        },
      ];
    }
    if (type === ICategory.Parcel) {
      return [
        {
          value: IOrderTime.ParcelCreatedDate,
          label: getI18n('general.parcelCreatedDate'),
        },
      ];
    }
    if (type === ICategory.Inventory) {
      return [
        {
          value: IOrderTime.ProductCreatedDate,
          label: getI18n('general.productCreatedDate'),
        },
      ];
    }
    if (type === ICategory.GiftCard) {
      return [
        {
          value: IOrderTime.GiftcardCreatedDate,
          label: getI18n('general.giftcardCreatedDate'),
        },
      ];
    }
    if (type === ICategory.SubscriptionBuy) {
      return [
        {
          value: IOrderTime.SubscriptionCreatedDate,
          label: getI18n('general.subscriptionCreatedDate'),
        },
      ];
    }
    if (type === ICategory.Order) {
      return [
        {
          value: IOrderTime.OrderPaidTime,
          label: getI18n('general.orderPaidDate'),
        },
        {
          value: IOrderTime.OrderCreatedTime,
          label: getI18n('general.orderCreatedDate'),
        },
      ];
    }
    if (type === ICategory.Promotion) {
      return [
        {
          value: IOrderTime.OrderPaidTime,
          label: getI18n('general.orderPaidDate'),
        },
      ];
    }
    return [];
  };
  // const { run: _getDateRange } = useRequest((data) => getDateRange(data), {
  //   manual: true,
  //   onSuccess: (res, params) => {
  //     onChange({ ...value, beginDate: res.begin, endDate: res.end });
  //   },
  // });
  // useEffect(() => {
  //   if (dateRange && dateRange !== IDateRange.Custom) {
  //     _getDateRange(dateRange);
  //   }
  // }, [dateRange]);
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf('day');
  };

  const handleSelectChange = (select) => {
    // if (select !== IDateRange.Custom) {
    //   _getDateRange(dateRange);
    // }
    onChange({ ...value, dateRange: select });
  };
  const handleDateRangeTypeChange = (dateRangeType) => {
    onChange({ ...value, dateRangeType });
  };
  const handleRangeChange = (_, array) => {
    onChange({ ...value, beginDate: array[0], endDate: array[1] });
  };
  return (
    <div className={css.dateRange}>
      <Select
        formProps={{ className: `${css.type} ${css.orderGenerateType}` }}
        value={dateRangeType}
        size='large'
        onChange={handleDateRangeTypeChange}
        disabled={disabled || isPromotion}>
        <React.Fragment>
          {generatorOptions().map((i) => {
            const { label, value } = i;
            return (
              <Option value={value} key={value}>
                {label}
              </Option>
            );
          })}
        </React.Fragment>
        {/* {additionalCustomerType ? (
          <Option value={IOrderTime.RegistrationDate}>
            {getI18n('general.registrationDate')}
          </Option>
        ) : (
          <React.Fragment>
            <Option value={IOrderTime.OrderCreatedTime}>
              {getI18n('general.ordercreatedtime')}
            </Option>
            <Option value={IOrderTime.OrderPaidTime}>
              {getI18n('general.orderpaidtime')}
            </Option>
          </React.Fragment>
        )} */}
      </Select>
      <Select
        formProps={{ className: css.type }}
        value={dateRange}
        size={size}
        onChange={handleSelectChange}
        disabled={disabled}>
        <Option value={IDateRange.Custom}>{getI18n('general.custom')}</Option>
        <Option value={IDateRange.Today}>{getI18n('general.today')}</Option>
        <Option value={IDateRange.Yesterday}>
          {getI18n('general.yesterday')}
        </Option>
        <Option value={IDateRange.Last24Hours}>
          {getI18n('general.last24hours')}
        </Option>
        <Option value={IDateRange.Last7Days}>
          {getI18n('general.last7days')}
        </Option>
        <Option value={IDateRange.Last30Days}>
          {getI18n('general.last30days')}
        </Option>
        <Option value={IDateRange.Last90Days}>
          {getI18n('general.last90days')}
        </Option>
        <Option value={IDateRange.LastCalendarMonth}>
          {getI18n('general.lastmonth')}
        </Option>
        <Option value={IDateRange.LastCalendarYear}>
          {getI18n('general.lastyear')}
        </Option>
        <Option value={IDateRange.WeekToDate}>
          {getI18n('general.weektodate')}
        </Option>
        <Option value={IDateRange.MonthToDate}>
          {getI18n('general.monthtodate')}
        </Option>
        <Option value={IDateRange.QuarterToDate}>
          {getI18n('general.quartertodate')}
        </Option>
        <Option value={IDateRange.YearToDate}>
          {getI18n('general.yeartodate')}
        </Option>
      </Select>
      <RangePicker
        onChange={handleRangeChange}
        className={css.range}
        disabled={dateRange !== IDateRange.Custom || disabled}
        disabledDate={disabledDate}
        value={[
          beginDate ? moment(beginDate) : null,
          endDate ? moment(endDate) : null,
        ]}
      />
      {isCustom && onButtonClick && (
        <Button
          type={'primary'}
          size='large'
          style={{ marginLeft: 12 }}
          loading={searchBtnLoading}
          onClick={onButtonClick}>
          {getI18n('general.apply')}
        </Button>
      )}

      {timeZone && (
        <p className={css.generated}>
          {getI18n('general.thisreportwasgeneratedon')}
          {refreshDate} (GMT{timeZone})
        </p>
      )}
      {onRefresh && (
        <span className={css.refresh} onClick={onRefresh}>
          {getI18n('general.refresh')}
        </span>
      )}
    </div>
  );
};

export default DateRange;
